module.exports = __webpack_public_path__ + "static/img/7.82c222f.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/7.png
// module id = WvfN
// module chunks = 9